import { useSnackbar } from '@app/snackbar'
import RoundedButton from '@app/ui/rounded-button/RoundedButton'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTheme } from 'styled-components'
import * as S from './AddTeeOverlay.styles'
import { Theme } from '@app/ui/theme'
import {
  isTeeRowComplete,
  teeFromRow,
  TeeGrid,
  TeeRow,
  TeeRowHeader,
} from './TeeRow'
import { DEFAULT_TEE_COLOR } from '../teeSets'

const renderButtons = (
  type: string,
  theme: Theme,
  acceptFunction: () => void,
  deleteFunction: () => void,
  editFunction: () => void
) => {
  if (type === 'edit') {
    return (
      <>
        <RoundedButton
          title="DELETE TEE"
          onPress={deleteFunction}
          style={{
            height: '50px',
            backgroundColor: theme.colors.warning,
          }}
          testId={'button'}
        />
        <RoundedButton
          title="SAVE CHANGES"
          onPress={editFunction}
          style={{
            height: '50px',
            backgroundColor: theme.colors.secondary2,
          }}
          testId={'button'}
        />
      </>
    )
  }
  return (
    <RoundedButton
      title="CREATE"
      onPress={acceptFunction}
      style={{
        height: '50px',
        backgroundColor: theme.colors.secondary2,
      }}
    />
  )
}

const AddTeeOverlay = ({
  type,
  addTee,
  deleteTee,
  editTee,
  tee,
}: {
  type: string
  addTee: any
  deleteTee: any
  editTee: any
  tee: any
}) => {
  const dispatch = useDispatch<any>()
  const theme = useTheme() as Theme

  // The same row the set of tees is filled in with, holding one tee.
  const [row, setRow] = useState({
    title: tee?.title ?? '',
    color: tee?.color || DEFAULT_TEE_COLOR,
    courseRating: tee?.courseRating ? String(tee.courseRating) : '',
    slopeRating: tee?.slopeRating ? String(tee.slopeRating) : '',
  })
  const [showErrors, setShowErrors] = useState(false)
  const [openSnackbar] = useSnackbar()

  const snackbarText = 'Please fill in all the fields before creating a new tee'

  const closeModal = () => {
    dispatch({
      type: 'SET_MODAL',
      params: null,
    })
  }

  const saveTee = (save: (newTee: ReturnType<typeof teeFromRow>) => void) => {
    if (!isTeeRowComplete(row)) {
      setShowErrors(true)
      openSnackbar(snackbarText)
      return
    }
    save(teeFromRow(row))
    closeModal()
  }

  // The tee is found by the name it was opened under, so renaming it here
  // still updates the tee that is on the form rather than adding another.
  const editTeeState = () => saveTee((newTee) => editTee(tee, newTee))

  const addTeeToState = () => saveTee((newTee) => addTee(newTee))

  const removeTeeFromState = () => deleteTee(tee)

  return (
    <S.TeeWrapper>
      <S.TeeHeader>
        <S.TeeTitle>{type === 'edit' ? 'Edit Tee' : 'Add Tee'}</S.TeeTitle>
        <S.CloseButton onClick={closeModal}>X</S.CloseButton>
      </S.TeeHeader>
      <S.TeeLine></S.TeeLine>
      <S.TeeContent>
        <TeeGrid>
          <TeeRowHeader />
          <TeeRow
            label="Tee"
            value={row}
            showErrors={showErrors}
            onChange={(update) => setRow({ ...row, ...update })}
          />
        </TeeGrid>

        <S.ButtonContainer>
          {renderButtons(
            type,
            theme,
            addTeeToState,
            removeTeeFromState,
            editTeeState
          )}
        </S.ButtonContainer>
      </S.TeeContent>
    </S.TeeWrapper>
  )
}

export default AddTeeOverlay
